// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3FKGQ","savePackageButton":"ClientWallet_savePackageButton__399u-"};